import * as React from "react"
const BlueIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    fill="none"
    {...props}
  >
    <circle cx={10} cy={10} r={10} fill="#4194F9" />
  </svg>
)
export default BlueIcon
